import { render, staticRenderFns } from "./InsuranceChecklist.vue?vue&type=template&id=2dbbdb1a&"
import script from "./InsuranceChecklist.vue?vue&type=script&lang=js&"
export * from "./InsuranceChecklist.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceChecklist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports